import { render, staticRenderFns } from "./GradeSubjectDetail.vue?vue&type=template&id=56e3258a"
import script from "./GradeSubjectDetail.vue?vue&type=script&lang=js"
export * from "./GradeSubjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports